// logo/index.ts
import logo from "./logo.png";
import logoSvg from "./logo.svg";
import logoBanner from "./logo_banner.png";
import junoLogoMini from "./juno-logo-mini.png";
import junoLogoMini2 from "./juno-logo-mini2.png";
import junoLogo from "./juno-logo.png";
import logoZISmall from "./logoZI-small.png";
import logoZI from "./logoZI.png";
import logoZISvg from "./logoZI.svg";
import nnIco from "./NN.ico";
import nnPng from "./NN.png";
import diocodeBlack from "./Diocode-2-black-high-res.png";
import diocodeWhite from "./Diocode-2-white-high-res.png";

const Logo = {
  main: logo,
  svg: logoSvg,
  banner: logoBanner,
  juno: {
    logo: junoLogo,
    mini: junoLogoMini,
    mini2: junoLogoMini2,
  },
  tenak: {
    logo: logoZI,
    small: logoZISmall,
    svg: logoZISvg,
  },
  notesNebula: {
    ico: nnIco,
    png: nnPng,
  },
  diocode: {
    black: diocodeBlack,
    white: diocodeWhite,
  },
};

export default Logo;

// 個別エクスポート
export {
  logo,
  logoSvg,
  logoBanner,
  junoLogoMini,
  junoLogoMini2,
  junoLogo,
  logoZISmall,
  logoZI,
  logoZISvg,
  nnIco,
  nnPng,
  diocodeBlack,
  diocodeWhite,
};
